// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { keyframes } from 'styled-components';

import config from '../../config/app.config';
import { Licences, Locales } from '../../types/common';

const MARGIN_TOP = 5;

const AD_HEIGHT_GAP = 10;
const SINGLE_AD_HEIGHT = 123.75;
const NB_VISIBLE_ADS = 4;

const progressiveOpacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  margin-top: ${MARGIN_TOP}px;

  .iframe {
    position: relative;
    height: ${SINGLE_AD_HEIGHT * NB_VISIBLE_ADS + AD_HEIGHT_GAP * (NB_VISIBLE_ADS - 1)}px;
    width: 100%;
    animation: ${progressiveOpacity} 1s ease-in 1 forwards;
  }
`;

type AdsIFrameProps = {
  license: string;
};

const AdsIFrame = ({ licence }: AdsIFrameProps) => {
  const show = useMemo(() => licence === Licences.DE, [licence]);
  const url = useMemo(() => {
    if (licence) {
      const lang = Locales[licence];
      if (lang) {
        return config.iframeDECRM[lang];
      }
    }
    return config.iframeDECRM['fr'];
  }, [licence]);

  return (
    show && (
      <Wrapper show={show}>
        <iframe
          title="Ads"
          className="iframe"
          src={url}
          scrolling="no"
          frameBorder="0"
          sandbox="allow-same-origin allow-top-navigation allow-scripts"
        />
      </Wrapper>
    )
  );
};

export default AdsIFrame;
